import withLoader from "../../../components/layouts/WithLoader";

import { useEffect, useState } from "react";
import WarehouseService from "../../../services/WarehouseService";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import makeAnimated from "react-select/animated";
import Select from "react-select";
import { Alert } from "@material-ui/lab";
import { Snackbar } from "@material-ui/core";
import { TextField } from "@material-ui/core";
import CurrencyInput from "react-currency-input";
import PromoCaisseService from "../../../services/MarketingService/PromoCaisseService";
import { useNavigate } from "react-router-dom";
const styles = {
  container: (base) => ({
    ...base,
    flex: 1,
  }),
};
const AddPromo = ({ startLoading, stopLoading }) => {
  const animatedComponents = makeAnimated();

  const navigate=useNavigate();
  const [warehousesSource, setWarehousesSource] = useState([]);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [allWarehouseSource, setAllWarehouseSource] = useState([{}]);
  const typePromo = [
    { value: "PERCENT", label: "Pourcentage" },
    { value: "AMOUNT", label: "Montant" },
  ];
  const [value, setValue] = useState(0);
  const [typePromoPercent, setTypePromoPercent] = useState();
  const [selectedOption, setSelectedOption] = useState(null);
  const [warehouseSourceId, setWarehouseSourceId] = useState(0);
  const [warehouseSelectPlaceHolder, setWarehouseSelectPlaceHolder] =
    useState("Choisir...");
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState();
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();
  const [startDate, setStartDate] = useState("");
  const [extrats, setExtrats] = useState([]);
  const [endDate, setEndDate] = useState("");
  const [name, setName] = useState("");

  useEffect(() => {
    startLoading();
    WarehouseService.getAllRealWarehouse(getCurrentUserId(), 0)
      .then((response) => {
        if (response.data.success) {
          setWarehousesSource(response.data.success);
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : pas de dépôt");
        }
      })
      .catch((e) => {
        console.log("error in getAllRealWarehouse", e);
      })
      .finally(() => {
        stopLoading();
      });
  }, []);

  useEffect(() => {
    warehousesSource &&
      warehousesSource.map((element) => {
        let exist = false;
        if (allWarehouseSource.length !== 0) {
          for (let index = 0; index < allWarehouseSource.length; index++) {
            if (allWarehouseSource[index].value === element?.id) {
              exist = true;
              break;
            }
          }
        }
        if (element?.id !== undefined && exist === false) {
          setAllWarehouseSource((oldArray) => [
            ...oldArray,
            { value: element.id, label: element.name },
          ]);
        }
        //here
      });
  }, [warehousesSource]);

  const onChangeSelectedWarehouseSource = (selectedOptionn) => {
    setSelectedOption();
    setWarehouseSourceId(selectedOptionn.value);
    setWarehouseSelectPlaceHolder(selectedOptionn.label);
  };
  const onChangeSelectedTypePromo = (selectedOptionn) => {
    setSelectedOption();
    setTypePromoPercent(selectedOptionn.value);
  };
  

  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };
  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const onChangeStartDate = (event) => {
    setStartDate(event.target.value.concat(":59"));
  };
  const onChangeEndDate = (event) => {
    setEndDate(event.target.value.concat(":59"));
  };
  const handlerChangeName = (event) => {
    setName(event.target.value);
  };



  const changeValeur = (event) => {
    setValue(event.target.value.replace(",", ""));
  };
 


  function addClick() {
    setExtrats((oldArray) => [
      ...oldArray,
      {
        typePromoPercent: typePromoPercent,
        value: value,
      },
    ]);
  }
  function createUI() {
    return (
      <div class="row">
        <div class="col-md-4">
          <label>Type </label>
          <Select
            styles={styles}
            closeMenuOnSelect={true}
            components={animatedComponents}
            defaultValue={selectedOption}
            onChange={onChangeSelectedTypePromo}
            options={typePromo}
            placeholder={typePromoPercent}
          />
        </div>
        <div class="col-md-4">
          <label>Valeur </label>

          <div className="input-group">
            <div className="input-group-prepend" style={{ width: "85%" }}>
              <CurrencyInput
                id="montantDevise"
                className="form-control"
                precision="3"
                value={value}
                onChangeEvent={changeValeur}
              />
            </div>
          </div>
        </div>

        <div class="col-md-4">
          <br />
          <button
            type="button"
            class="btn btn-dark float-right"
            onClick={addClick}
          >
            <i class="fa fa-plus"></i>
          </button>
        </div>
      </div>
    );
  }
  const removeExtrat = (index) => {
    var array = [...extrats];

    if (index !== -1) {
      array.splice(index, 1);
      setExtrats(array);
    }
  };
  function addExtratToView() {
    if (extrats.length === 0) {
      return (
        <div class="row">
          <div class="col-xs-12 table-responsive">
            <h1></h1>
          </div>
        </div>
      );
    } else if (extrats.length === 1 && extrats[0]["value"] === "") {
      return (
        <div class="row">
          <div class="col-xs-12 table-responsive">
            <h1></h1>
          </div>
        </div>
      );
    } else {
      return (
        <div className="table-responsive">
          <table className="table table-striped">
            <tbody>
              {extrats.map((extrat, i) => (
                <tr className="text-center">
                  <td>{extrat.typePromoPercent}</td>
                  <td>{extrat.value}</td>

                  <td>
                    <button
                      type="button"
                      class="btn btn-danger float-right"
                      onClick={() => removeExtrat(i)}
                    >
                      <i class="fa fa-minus"></i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      );
    }
  }
    const onAddPromoGroupe = () => {
      if (name == null) {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur :le nom est vide ! ");
      } else {
        let promoAddModel = {
          name: name,
          idUser: getCurrentUserId(),
          dateDebut: startDate,
          dateFin: endDate,
          idWarehouse: warehouseSourceId,
          promos: extrats,

        };
        console.log("promoAddModel", promoAddModel);
        startLoading();
        PromoCaisseService.addPromoCaisse(promoAddModel)
          .then((response) => {
            console.log("response", response.data["success"]);
            if (response.data.success) {
              setOpenSuccessAlert(true);
              setSuccessAlertText("Enregistrement avec succées");
              setTimeout(() => {
                navigate(`/cartesCadeaux`);
              }, 2000);
            } else {
              setOpenErrorAlert(true);
              setErrorAlertText("Erreur :erreur serveur ");
            }
          })
          .catch((e) => {
            console.log("error in allDiscounts", e);
          })
          .finally(() => {
            stopLoading();
          });
      }
    };
  
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6"></div>
            <div className="col-md-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item">Home</li>
                <li class="breadcrumb-item active">Ajouter une carte cadeau</li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <section className="content ">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card card-dark">
                <div className="card-header">
                  <h5 className="card-title">Ajouter une carte cadeau</h5>
                </div>
                <div className="card-body">
                  <div class="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <label>Choisir le dépôt </label>
                        <div style={{ width: "100%" }}>
                          <Select
                            styles={styles}
                            closeMenuOnSelect={true}
                            components={animatedComponents}
                            defaultValue={selectedOption}
                            onChange={onChangeSelectedWarehouseSource}
                            options={allWarehouseSource}
                            placeholder={warehouseSelectPlaceHolder}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-4">
                      <div class="form-group">
                        <label>Choisir le libellé </label>
                        <input
                          onChange={handlerChangeName}
                          type="text"
                          id="inputClientCompany"
                          className="form-control"
                        />
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <div className="form-group">
                        <label htmlFor="inputName">Date début</label>

                        <TextField
                          style={{ width: "100%" }}
                          className="col-sm-12"
                          variant="outlined"
                          value={startDate}
                          onChange={onChangeStartDate}
                          id="datetime-local"
                          type="datetime-local"
                          defaultValue="date"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          size="small"
                        />
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <div className="form-group">
                        <label htmlFor="inputName">Date fin</label>

                        <TextField
                          style={{ width: "100%" }}
                          className="col-sm-12"
                          variant="outlined"
                          value={endDate}
                          onChange={onChangeEndDate}
                          id="datetime-local"
                          type="datetime-local"
                          defaultValue="date"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          size="small"
                        />
                      </div>
                    </div>
                  </div>

                  {createUI()}

                  <br />
                  {addExtratToView()}

                </div>
                <div class="card-footer">
                  <div className="col-sm-12  text-center">
                    <button
                      className="btn btn-dark float-right"
                      onClick={onAddPromoGroupe}
                    >
                      Confirmer
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Snackbar
        open={openInfoAlert}
        autoHideDuration={4000}
        onClose={handleInfoClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleInfoClose} severity="info">
          {infoAlertText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default withLoader(AddPromo);
